export default {"src":"/_next/static/media/trtl.b1064e59.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};